/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Err_Otp_RequiredInputs */

const es_ab_err_otp_required = /** @type {(inputs: Ab_Err_Otp_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce el código de verificación`)
};

const gl_ab_err_otp_required = /** @type {(inputs: Ab_Err_Otp_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce o código de verificación`)
};

const en_ab_err_otp_required = /** @type {(inputs: Ab_Err_Otp_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the verification code`)
};

/**
* | output |
* | --- |
* | "Enter the verification code" |
*
* @param {Ab_Err_Otp_RequiredInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_err_otp_required = /** @type {((inputs?: Ab_Err_Otp_RequiredInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Err_Otp_RequiredInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_err_otp_required(inputs)
	if (locale === "en") return en_ab_err_otp_required(inputs)
	return es_ab_err_otp_required(inputs)
});